import { change } from 'redux-form';
import { FORM_NAME } from '../Form';
import promptForEstimateOptionals from '../Services/promptForEstimateOptionals';
import selectEstimates from '../Selectors/selectEstimates';
import selectClientContacts from '../Selectors/selectClientContacts';

export default (event, value) => (dispatch, getState) => {

  dispatch(change(FORM_NAME, 'estimate_optional_ids', []))

  if (value) {
    dispatch(promptForEstimateOptionals(value))

    const estimates = selectEstimates(getState());
    const estimate = estimates.find(item => item.id === value);

    if (estimate) {
      dispatch(change(FORM_NAME, 'extra_works', estimate.extra_works));

      // match against the loaded contacts list so the value type lines up with the dropdown options
      const clientContacts = selectClientContacts(getState());
      const clientContact = clientContacts.find(item => item.id == estimate.client_contact_id); // eslint-disable-line eqeqeq

      dispatch(change(FORM_NAME, 'client_contact_id', (clientContact && clientContact.id) || null));
    }

  } else {

    // no estimate selected - default extra_works based on whether the project has existing orders
    const project = getState().modals.Order.project;
    const hasExistingOrders = !!(project && project.orders && project.orders.length > 0);
    dispatch(change(FORM_NAME, 'extra_works', hasExistingOrders ? 1 : 0));  // 0 = New Works, 1 = Extra Works

  }

}
